import getPageCustomizableHeaderProps from 'hb-react/shared/apps/PageCustomizables/utils/getPageCustomizableHeaderProps';

import getMentorshipsHeaderControls from '../getMentorshipsHeaderControls';

const getMentorshipsHeaderProps = ({
  appPageConfig,
  currentUser,
  currentNetwork,
  topic,
  customAttributesList,
}) => {
  if (!appPageConfig) {
    return null;
  }

  const { controls } = getMentorshipsHeaderControls({
    appPageConfig,
    currentUser,
    currentNetwork,
    topic,
    customAttributesList,
  });

  const headerProps = getPageCustomizableHeaderProps({
    appPageConfig,
    controls,
  });

  return headerProps;
};

export default getMentorshipsHeaderProps;
